export default "__VITE_ASSET__c7731174__"